export const volumes = [
  {
    number: '01',
    tone: 'rose',
    title: 'Preparate para la llegada de tu bebé',
    tagline: 'Todo lo que necesitás organizar antes del nacimiento.',
    body: 'Prepará tu hogar, elegí los artículos esenciales, organizá el bolso de maternidad y conocé los primeros cuidados de tu bebé mediante guías claras e ilustradas.',
    flow: ['Preparar', 'Organizar', 'Recibir'],
  },
  {
    number: '02',
    tone: 'sage',
    title: 'Cuidados diarios de tu bebé',
    tagline: 'Aprendé los cuidados cotidianos paso a paso.',
    body: 'Guías visuales sobre baño, cambio de pañales, higiene, cordón umbilical, vestimenta y prevención de accidentes.',
    flow: ['Conocer', 'Cuidar', 'Prevenir'],
  },
  {
    number: '03',
    tone: 'honey',
    title: 'Alimentación y lactancia sin confusiones',
    tagline: 'Comprendé mejor cómo alimentar a tu bebé.',
    body: 'Información práctica sobre lactancia, agarre, señales de hambre, extracción de leche y alimentación con fórmula cuando corresponde.',
    flow: ['Comprender', 'Alimentar', 'Consultar'],
  },
  {
    number: '04',
    tone: 'rose',
    title: 'Sueño, llanto y desarrollo de tu bebé',
    tagline: 'Entendé sus señales y acompañá su crecimiento.',
    body: 'Aprendé sobre sueño seguro, llanto, formas de consuelo y actividades apropiadas para sus primeros meses.',
    flow: ['Observar', 'Comprender', 'Acompañar'],
  },
  {
    number: '05',
    tone: 'sage',
    title: 'Mamá también importa: posparto y bienestar',
    tagline: 'Porque tu bienestar también es importante.',
    body: 'Una guía sobre recuperación posparto, cambios emocionales, descanso, autocuidado y búsqueda de apoyo.',
    flow: ['Recuperar', 'Cuidarte', 'Pedir apoyo'],
  },
];
